import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Slugger from 'github-slugger';
import striptags from 'striptags';
import styled from 'styled-components';
import useScroll from 'react-use/lib/useScroll';
import useWindowSize from 'react-use/lib/useWindowSize';

import { trackEvent } from '../../utils';

function onHeadingClick(e) {
  trackEvent({
    eventCategory: 'Section Nav',
    eventAction: 'heading click',
    eventLabel: e.target.innerText,
  });
}

export default function SectionNav(props) {
  const { y } = useScroll(props.mainRef);
  const { width, height } = useWindowSize();
  const [offsets, setOffsets] = useState([]);

  const { contentRef, imagesLoaded } = props;
  useEffect(() => {
    const headings = contentRef.current.querySelectorAll('h1, h2, h3, h4');
    setOffsets(
      Array.from(headings)
        .map(heading => {
          const anchor = heading.querySelector('a');
          if (!anchor) {
            return null;
          }

          return {
            id: heading.id,
            offset: anchor.offsetTop,
          };
        })
        .filter(Boolean)
    );
  }, [width, height, contentRef, imagesLoaded]);

  let activeHeading = null;
  const windowOffset = height / 2;
  const scrollTop = y + windowOffset;
  for (let i = offsets.length - 1; i >= 0; i--) {
    const { id, offset } = offsets[i];
    if (scrollTop >= offset) {
      activeHeading = id;
      break;
    }
  }

  const slugger = new Slugger();
  return (
    <List>
      {props.headings.map(({ value, depth }) => {
        const text = striptags(value);
        const slug = slugger.slug(text);
        return (
          <li
            className={`toc-item toc-item--depth${depth} ${
              slug === activeHeading ? 'toc-item--active' : ''
            }`.trim()}
            key={slug}>
            <a href={`#${slug}`} onClick={onHeadingClick}>
              {text}
            </a>
          </li>
        );
      })}
    </List>
  );
}

SectionNav.propTypes = {
  headings: PropTypes.array.isRequired,
  imagesLoaded: PropTypes.bool.isRequired,
  mainRef: PropTypes.object.isRequired,
  contentRef: PropTypes.object.isRequired,
};

const List = styled.ul`
  margin-left: 0;
  margin-bottom: 48px;
  overflow: auto;
  padding: 0;
  opacity: 0.9;

  .toc-item {
    list-style: none;
    line-height: 2;
    font-size: 1rem;
    color: ${props => props.theme.palette.text.primary};
    a {
      color: inherit;
      text-decoration: none;

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .toc-item--active {
    color: ${props => props.theme.colors.blue};
  }

  .toc-item--depth2 {
  }
  .toc-item--depth3 {
    padding-left: 1.2rem;
  }
  .toc-item--depth4 {
    padding-left: 2.4rem;
  }
  .toc-item--depth5 {
    padding-left: 3.6rem;
  }
`;
